import { ComponentType, FC, PropsWithChildren, useMemo } from 'react';

import { PaletteMode, ThemeProvider, useTheme } from '@mui/material';
import { theme as createTheme } from 'common/theme';

type Props = {
  mode?: PaletteMode;
};

export const NatterThemeProvider = ({ children, mode = 'light' }: PropsWithChildren<Props>) => {
  const theme = useMemo(() => createTheme(undefined, mode), [mode]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export const NatterDarkThemeProvider = ({ children }: PropsWithChildren) => {
  const { palette } = useTheme();

  return <ThemeProvider theme={{ palette: { ...palette, mode: 'dark' } }}>{children}</ThemeProvider>;
};

export const withTheme =
  (config: Props) =>
  <P extends object>(WrappedComponent: ComponentType<P>): FC<P> =>
  (props) => (
    <NatterThemeProvider {...config}>
      <WrappedComponent {...props} />
    </NatterThemeProvider>
  );
